import { StringParam, useQueryParams, withDefault } from 'use-query-params'

import VolumePill from 'components/idea-lab/VolumePill'
import { KeywordCategory } from 'container/SEOTools/types'

import s from './RecentCategoryCard.module.css'

type Props = {
  category: KeywordCategory
}

const RecentCategoryCard = ({ category }: Props) => {
  const [_, setQueryParams] = useQueryParams({
    category_id: withDefault(StringParam, undefined),
    step: withDefault(StringParam, undefined),
  })

  const handleClick = () => {
    setQueryParams({
      category_id: category.id,
      step: 'themes',
    })
  }

  return (
    <button className={s.wrapper} onClick={handleClick}>
      <div title={category.category} className={s.category}>
        {category.category}
      </div>
      <VolumePill value={category.volume} />
    </button>
  )
}

export default RecentCategoryCard
